import * as actions from '../actions/actionTypes';

const initialState = {
  token: null,
  companyCode: null,
  socialName: null,
  userName: null,
  isEmployee: null,
  cnpj: null,
  businessName: null,
  privileges: {},
};

const authSuccess = (state, action) => {
  return {
    ...state,
    token: action.token,
    companyCode: action.companyCode,
    socialName: action.socialName,
    userName: action.userName,
    isEmployee: action.isEmployee,
    cnpj: action.cnpj,
    businessName: action.businessName,
    privileges: action.privileges,
  };
};

const employeeAuth = (state, action) => ({
  ...state,
  token: action.token,
  companyCode: action.companyCode,
  socialName: action.socialName,
  userName: action.userName,
  isEmployee: action.isEmployee,
  businessName: action.businessName,
});

const authLogout = state => ({
  ...state,
  token: null,
  companyCode: null,
  socialName: null,
  userName: null,
  isEmployee: null,
  cnpj: null,
  businessName: null,
  privileges: {},
});


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actions.AUTH_LOGOUT:
      return authLogout(state);
    case 'EMPLOYEE_AUTH':
      return employeeAuth(state, action);
    default:
      return state;
  }
};

export default reducer;
